import * as React from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { copyToClipboard } from 'core/utils/copyToClipboard';
import './copyable-text.scss';

interface Props {
    value?: string | null;
    // نام مقدار برای پیام «... کپی شد» و تولتیپ دکمه
    label?: string;
    className?: string;
    empty?: React.ReactNode;
}

// نمایش یک مقدار همراه با دکمه کپی
export const CopyableText: React.FC<Props> = ({ value, label = 'مقدار', className, empty = '-' }) => {
    if (!value) return <span className="en">{empty}</span>;

    return (
        <span className={`pmx-copyable-text${className ? ` ${className}` : ''}`}>
            <span className="en">{value}</span>
            <Tooltip title={`کپی ${label}`}>
                <button
                    type="button"
                    className="copy-button"
                    aria-label={`کپی ${label}`}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        copyToClipboard(value, label);
                    }}
                >
                    <CopyOutlined />
                </button>
            </Tooltip>
        </span>
    );
};
